
import SocialMediaType from '@/enums/SocialMediaType';

export default {
  i18nComponentKey: 'ReviewsShow.components.SocialMediaLinkBar',
  name: 'SocialMediaLinkBar',
  props: {
    review: { type: Object, required: true }
  },
  computed: {
    socialMediaTypeName() {
      switch (this.review.social_media_type) {
        case SocialMediaType.FACEBOOK:
          return 'facebook';
        case SocialMediaType.INSTAGRAM:
          return 'instagram';
        case SocialMediaType.NAVER_CAFE:
          return 'naver_cafe';
        case SocialMediaType.NAVER_BLOG:
          return 'naver_blog';
        case SocialMediaType.YOUTUBE:
          return 'youtube';
        case SocialMediaType.VIMEO:
          return 'vimeo';
        default:
          return '';
      }
    }
  }
};
